import { codeSchemaFields } from "./code";
export function commonResponseBody(title, dataRequired) {
  return {
    title: '返回包体',
    type: 'object',
    fields: [{
      id: 'data',
      required: dataRequired,
      type: 'object',
      title,
      injectEntity: true
    }, ...codeSchemaFields]
  };
}
//# sourceMappingURL=commonResponseBody.js.map
